import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'
import './styles.css'

function PaymentMethod({
  cardType = '',
  imageUrl,
  email = '',
  last4 = '',
  expirationMonth = '',
  expirationYear = '',
  isMobile = false,
  default: isDefault = false,
  isSubscribed = false,
  setDefault = () => {},
  setDefaultWithConfirmation = () => {},
  remove = () => {}
}) {
  const isPaypal = _.isEmpty(cardType)

  return (
    <div className="payment-method">
      <div className="payment-method-container">
        <div className="mobile-container">
          <div className="payment-method-body">
            <div className="credit-card-icon">
              <img src={imageUrl} alt={cardType} />
            </div>
            <div className="payment-method-description">
              <div className="card-description">
                {!isPaypal && <div className="payment-method-name card-type">{cardType}</div>}
                {isPaypal && _.isString(email) && (
                  <div className="payment-method-name paypal-name">
                    {email.slice(0, 30)}
                    {email.length > 30 && <span>...</span>}
                  </div>
                )}
                {!isPaypal && <div className="card-last-four">ending in {last4}</div>}
                {!isMobile && !isPaypal && <div className="separator">-</div>}
                {!isPaypal && (
                  <div className="card-expiration">
                    {expirationMonth}/{expirationYear}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="primary">
            <div className={classnames({ 'is-primary': isDefault })}>
              <button
                type="button"
                onClick={isDefault ? null : () => (isSubscribed ? setDefaultWithConfirmation() : setDefault())}
              >
                {isDefault ? 'primary' : 'make primary'}
              </button>
            </div>
          </div>
        </div>
        <div className="remove">
          <div className="remove-btn-container">
            {!isDefault && (
              <div
                onClick={() => remove()}
                onKeyDown={(e) => e.key === 'Enter' && remove()}
                className="cross"
                role="button"
                tabIndex={0}
              >
                <i className="icon-x" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export const PaymentMethodStructure = {
  cardType: PropTypes.string,
  expirationMonth: PropTypes.string,
  expirationYear: PropTypes.string,
  default: PropTypes.bool,
  imageUrl: PropTypes.string.isRequired,
  last4: PropTypes.string,
  token: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  email: PropTypes.string,
  isSubscribed: PropTypes.bool,
  setDefault: PropTypes.func,
  setDefaultWithConfirmation: PropTypes.func,
  remove: PropTypes.func
}

PaymentMethod.propTypes = PaymentMethodStructure

export default PaymentMethod
